import { render } from "./FloristMeetingAgenda.vue?vue&type=template&id=b2874492&scoped=true"
import script from "./FloristMeetingAgenda.vue?vue&type=script&lang=js"
export * from "./FloristMeetingAgenda.vue?vue&type=script&lang=js"

import "./FloristMeetingAgenda.vue?vue&type=style&index=0&id=b2874492&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2874492"]])

export default __exports__